// extracted by mini-css-extract-plugin
export var aggregationCell = "_2i-p";
export var aggregationRow = "_2i-o";
export var borderlessSpinnerContainer = "_2i-3";
export var cardLayout = "_2i-6";
export var cardLayoutNoFooter = "_2i-a";
export var cardLayoutPageControl = "_2i-9";
export var cardLayoutWithFooter = "_2i-8";
export var closeIcon = "_2i-h";
export var columnHeaderSurface = "_2i-d";
export var columnHeaderSurfaceDragOverlay = "_2i-x";
export var columnHeaderSurfaceResizing = "_2i-u";
export var contextMenuAnchor = "_2i-1";
export var draggableColumnHeader = "_2i-v";
export var draggableColumnHeaderOverlay = "_2i-w";
export var expandIcon = "_2i-i";
export var expanded = "_2i-j";
export var filterDropdown = "_2i-k";
export var filterDropdownDivider = "_2i-f";
export var filterDropdownHeader = "_2i-n";
export var filterDropdownItem = "_2i-m";
export var filterDropdownModal = "_2i-l _2i-k";
export var filterItem = "_2i-e";
export var normalCellWithAdjustableBorder = "_2i-g";
export var pinButtonContainer = "_2i-q";
export var pinIcon = "_2i-r";
export var pinIconActive = "_2i-s";
export var spinner = "_2i-0";
export var spinnerContainer = "_2i-2";
export var tableContainer = "_2i-4";
export var tableContentDraggingColumns = "_2i-c";
export var tableContentInner = "_2i-7";
export var tableContentInnerFill = "_2i-b";
export var tableContentWrapper = "_2i-5";
export var viewButtonContainer = "_2i-t";